import { forwardRef, useRef, useEffect } from 'react';
import { useBodyScrollControl } from '@autopass-web/domain';
import { CoreIcon } from '@autopass-web/mochi-icons';
import styles from './index.module.sass';
import className from 'classnames/bind';

interface DialogLayoutProps {
  show: boolean;
  withClose?: boolean;
  contentClassName?: string;
  children: React.ReactNode;
  onDismiss?: () => void;
}

const cx = className.bind(styles);

const DialogLayout = forwardRef<HTMLDivElement, DialogLayoutProps>(
  (
    { show = false, withClose = false, contentClassName, children, onDismiss },
    ref,
  ) => {
    const bodyRef = useRef<HTMLElement | null>(null);
    const dialogLayoutClasses = cx({
      'dialog-layout': true,
      show,
    });

    useEffect(() => {
      bodyRef.current = document.body;
    }, []);

    useBodyScrollControl(bodyRef, show);

    return (
      <div
        ref={ref}
        className={dialogLayoutClasses}
        onClick={() => {
          if (onDismiss) onDismiss();
        }}
      >
        <div
          className={`${styles.content} ${contentClassName}`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {withClose && (
            <CoreIcon
              src="/assets/close.svg"
              onClick={onDismiss}
              className={styles.close}
            />
          )}
          {children}
        </div>
      </div>
    );
  },
);

export default DialogLayout;
